import {FC} from "react";
import {OrderInform} from "../";
import {Link} from "../../../ui";
import styled from "styled-components";
import useDrawer from "../../../hooks/useDrawer";
import Loading from "../../../ui/Loading/Loading";
import {LoadingIcon} from "../../../ui/Icons";
import {useGetOrderByIdQuery} from "./__generated__/OrderRoot.query.generated";

const Options = styled.div`
  h2 {
    font-weight: 400;
    color: ${props => props.theme.palette.purple};
  }
  ul {
    display: flex;
    flex-direction: column;
  }
`;

const OrderRoot:FC = () => {
  const { id, openChildrenHandler } = useDrawer();
  const { data, loading, error } = useGetOrderByIdQuery({ variables: { id }});

  if (loading || !data) {
    return (
      <Loading><LoadingIcon /></Loading>
    );
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  if (!data?.getOrderById) {
    return <p>Возможно произошла ошибка или ID был пуст</p>;
  }

  return (
     <>
       <OrderInform
         info={data?.getOrderById}
       />
       <Options>
         <h2>Управление заказом</h2>
         <ul>
           <Link colorTheme="green" onClick={() => openChildrenHandler('ordersSettingsStatus')}>Изменить статус</Link>
           <Link colorTheme="red" onClick={() => openChildrenHandler('ordersSettingsDelete')}>Удалить заказ</Link>
         </ul>
       </Options>
     </>
  )
}

export default OrderRoot;
